/**
 * @generated SignedSource<<2ab5034b028dfc608258fb7b7091509e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type InviteeRelationship = "MANAGER" | "SUBORDINATE" | "TEAMMATE";
export type InviteUsersMutationInput = {
  analytics: string;
  captchaToken: string;
  clientMutationId?: string | null;
  invitations: ReadonlyArray<InviteUserInput | null>;
};
export type InviteUserInput = {
  email: string;
  fullName: string;
  oneOnOneDetails?: InviteOneOnOneInput | null;
  relationship?: InviteeRelationship | null;
  sendInviteEmail?: boolean | null;
};
export type InviteOneOnOneInput = {
  eventEnd?: string | null;
  eventId?: string | null;
  eventStart?: string | null;
};
export type PostUpgradeModalContactMutation$variables = {
  input: InviteUsersMutationInput;
};
export type PostUpgradeModalContactMutation$data = {
  readonly inviteUsers: {
    readonly invitees: ReadonlyArray<{
      readonly errors: ReadonlyArray<{
        readonly field: string | null;
        readonly message: string;
      } | null> | null;
    }>;
  } | null;
};
export type PostUpgradeModalContactMutation = {
  response: PostUpgradeModalContactMutation$data;
  variables: PostUpgradeModalContactMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "InviteUsersMutationPayload",
    "kind": "LinkedField",
    "name": "inviteUsers",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "InviteUserOutput",
        "kind": "LinkedField",
        "name": "invitees",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FormError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "field",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PostUpgradeModalContactMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PostUpgradeModalContactMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2d22dfd474204c43361b00b514cdfd87",
    "id": null,
    "metadata": {},
    "name": "PostUpgradeModalContactMutation",
    "operationKind": "mutation",
    "text": "mutation PostUpgradeModalContactMutation(\n  $input: InviteUsersMutationInput!\n) {\n  inviteUsers(input: $input) {\n    invitees {\n      errors {\n        field\n        message\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "482f2e0e5dbccfeac1228e07e237f207";

export default node;
